<template>
  <div class="creation-contain">
    <p class="teacher">崔圣辉老师</p>
    <div class="info">
      <span class="label">正文：</span>
      <p class="content">{{ target.body }}</p>
      <span class="label">落款：</span>
      <p class="content">{{ target.inscriber }}</p>
      <span class="label">格式：</span>
      <p class="content">{{ target.charactersPerLine }}</p>
      <!-- <span class="label">字体：</span>
      <p class="content">{{ target.fontId }}</p> -->
    </div>
  </div>
</template>

<script>
export default {
  name: 'CreationContain',
  props: {
    item: {
      type: Object,
      required: true,
      default: () => {}
    }
  },
  computed: {
    target () {
      return this.item.target
    }
  }
}
</script>

<style scoped lang="scss">
.creation-contain {
  .teacher {
    @include sc($font-size-lg, $color-text-heavy);
    margin-bottom: 8px
  }
  .info {
    display: grid;
    grid-template-columns: 45px auto;
    grid-template-rows: auto;
    .label {
      @include sc($font-size-md, $color-text-light);
    }
    .content {
      @include sc($font-size-md, $color-text-medium);
      @include ellipsis(2, 18px);
    }
  }
}
</style>
